import { useMemo } from 'react';
import { useAuthStore } from '@/shared/stores/authStore';
import { getAvailableDomains } from '@/domain-registry';

/**
 * Returns the set of domain IDs the current user has access to.
 * Used to filter activity feed events to only show domains the user can see.
 */
export function useVisibleDomains(): Set<string> {
  const groupAccess = useAuthStore((s) => s.groupAccess);
  return useMemo(() => {
    return new Set(getAvailableDomains().map((d) => d.id));
  }, [groupAccess]);
}
